import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { IoMdLogOut } from "react-icons/io";


const Navigation = () => {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    // const [permissions, setPermissions] = useState([]);


    
        //    Pemisiion privillages atart 
        
            //  useEffect(() => {
            //         const adminId = localStorage.getItem('adminId') || '';
            //         axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            //             .then(res => setPermissions(res.data || []))
            //             .catch(() => setPermissions([]));
            //     }, []);
            
            //     // Permission check helper
            //     const hasPermission = useCallback((tabName, action) => {
            //         const tab = permissions.find(t => t.tabName === tabName);
            //         if (!tab) return false;
            //         switch (action) {
            //             case 'view': return !!tab.canView;
            //             case 'edit': return !!tab.canEdit;
            //             case 'download': return !!tab.canDelete; // using canDelete for download
            //             default: return false;
            //         }
            //     }, [permissions]);
        //    Pemisiion privillages end
    
    // const handleLogout= () => {
    //    localStorage.removeItem('adminId');
    //    localStorage.removeItem('password');
    //     navigate('/');
    // };

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };
    const handleLogout = () => {
        localStorage.removeItem('adminId');
        localStorage.removeItem('password');
        sessionStorage.clear();
        Cookies.remove('authToken');
        navigate('/');
    };
    return (
        <>
            <div className='loginbackground'>
                <div className="nav-inner">
                    <div className="nav-left">
                        <NavLink to="/" className="nav-logo-link">
                            <img src="../assets/images/logo.png" alt="Logo" height={44} />
                        </NavLink>
                    </div>
                    <div className="nav-center UjjawalSrijanmoney">
                        <span className="nav-title">UJJAWAL SRIJAN SOLUTION FOUNDATION</span>
                    </div>
                    <div className="nav-right">
                        <div className='userid'>
                            <img src="../assets/images/user.png" alt="user" width={38} height={38} onClick={toggleMenu} className="nav-avatar" />
                            <span className='super' onClick={toggleMenu}>
                                Admin
                                <span className='logoutbu'><IoMdLogOut /></span>
                            </span>
                            {showMenu && (
                                <div className='profile-menu'>
                                    <button className='menu-item' onClick={() => navigate('/privllages/Permissions')}>Privileges</button>
                                    <button className='menu-item' onClick={() => navigate('/setting')}>Settings</button>
                                    <button className='menu-item menu-item-logout' onClick={handleLogout}>Logout</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navigation;
